export default __webpack_public_path__ + "static/media/soundFive.b3bbfd78.wav";